//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dic from "../libs/dictionary";
export default {
  name: "fillList",
  data(){return{
    dic,
  }},
  props:{
    fieldsList: {type:Array,default:()=>([{
          list:[]
      }])},
    fillData: {type:Object,default:()=> ({})},
    edit:{type:Boolean,default:false,},
    showRequired:{type:Boolean,default:false,},
    labelAlign: {type:String,default:'left'},
    isMobile: {type:Boolean,default:false},
    customClassName: {type:String},
    noLabel:{type:Boolean,default:false},
    withIcon:{type:Boolean,default:true},
  },
  methods:{
    leftBlank(field){
      return this.$root.isMobile?0:field.list && field.list.length && field.colNum && field.colNum>1 && (field.list.length % field.colNum)?field.colNum-(field.list.length % field.colNum):0
    },
    getIcon(label){
      const icons={'学校':'school','姓名':'user','身份证':'id','公司':'company','机构':'company','单位':'company','证号':'number','编号':'number','验证码':'yzm'}
      let icon='qqzy'
      for(let i of Object.keys(icons)){
        if(label.includes(i)){
          icon=icons[i]
          break
        }
      }
      return require('../src/assets/imgs/'+icon+'.png')
    },
  },
  mounted() {
  }
}
